import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-object-viewer',
    templateUrl: './object-viewer.component.html',
    styleUrls: ['./object-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ObjectViewerComponent {
  readonly rows: Array<{ key: string; value: string }> = [];

  constructor(
      public dialogRef: MatDialogRef<ObjectViewerComponent>,
      @Inject(MAT_DIALOG_DATA) public data: ObjectViewerDialogModel
  ) {
    const obj = this.data?.data ?? {};
    const keys = Object.keys(obj).sort((a, b) => a.localeCompare(b));
    for (const key of keys) {
      const raw = obj[key];
      this.rows.push({ key, value: this.toDisplayString(raw) });
    }
  }

  doneClicked(): void {
    this.dialogRef.close();
  }

  trackByKey(index: number, row: { key: string }): string {
    return row.key;
  }

  private toDisplayString(value: unknown): string {
    if (value === null) return 'null';
    if (value === undefined) return 'undefined';
    if (typeof value === 'string') return value;
    if (typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint') return String(value);
    if (value instanceof Date) return value.toISOString();
    return String(value);
  }
}

export class ObjectViewerDialogModel {
  constructor(
      public data: Record<string, unknown>,
      public title: string = 'Object Viewer'
  ) {}
}
